import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import type { LoginPayload } from 'services/requests';
import { yupPasswordRequired } from 'utils';
import type { UseCustomFormReturn } from './useCustomForm';
import { useCustomForm } from './useCustomForm';
import { LoginFormErrors } from './formErrors';

export enum LoginFieldNames {
  userName = 'userName',
  password = 'password',
}

export const useLoginForm = (): UseCustomFormReturn<LoginPayload> => {
  const schema = yup.object().shape({
    userName: yup.string().max(64, '').required(LoginFormErrors.usernameRequired),
    password: yupPasswordRequired,
  });
  const resolver = yupResolver(schema);
  const form = useForm<LoginPayload>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver,
  });

  return useCustomForm(form, resolver);
};
